/* FORM site behaviour: hero crossfade, offer modal, gallery, size picker. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero: stacked layers crossfade, 7s timer, dots stop the rotation ---- */
  function initHero(root) {
    var layers = root.querySelectorAll('.f-hero__layer');
    var slides = root.querySelectorAll('[data-f-hero-slide]');
    var dots = root.querySelectorAll('[data-f-hero-dot]');
    if (layers.length < 2) return;
    var index = 0;
    var timer = null;
    /* slides 2+ ship loading="lazy" so they don't compete with the first (LCP) image; fetch them once the page has loaded */
    function warm() { layers.forEach(function (el) { el.loading = 'eager'; }); }
    if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); });

    function show(n) {
      index = n;
      layers.forEach(function (el, i) { el.classList.toggle('is-active', i === n); });
      slides.forEach(function (el, i) { el.classList.toggle('is-active', i === n); });
      dots.forEach(function (el, i) {
        el.classList.toggle('is-active', i === n);
        el.setAttribute('aria-current', i === n ? 'true' : 'false');
      });
    }
    var stopped = reduceMotion, paused = false;
    function start() { if (!timer && !stopped && !paused) timer = setInterval(function () { show((index + 1) % layers.length); }, 7000); }
    function halt() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopped = true; halt();
        show(i);
      });
    });
    /* pause while the pointer is over the hero or focus is inside it, so a focused button never slides away (WCAG 2.2.2) */
    root.addEventListener('mouseenter', function () { paused = true; halt(); });
    root.addEventListener('mouseleave', function () { paused = root.contains(document.activeElement); if (!paused) start(); });
    root.addEventListener('focusin', function () { paused = true; halt(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget) && !root.matches(':hover')) { paused = false; start(); } });
    show(0);
    start();
  }

  /* ---- Offer modal: Escape, overlay click, focus trap, focus return ---- */
  function initOffer(root) {
    var modal = root.querySelector('[data-f-offer]');
    var openBtn = root.querySelector('[data-f-offer-open]');
    var closeBtn = root.querySelector('[data-f-offer-close]');
    if (!modal || !openBtn) return;
    var lastFocus = null;

    function focusables() {
      return [].filter.call(modal.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.getClientRects().length > 0; });
    }
    /* auto = popped on scroll: focus the close button instead of the email field, so phones don't raise the keyboard unasked */
    function open(auto) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('f-offer-open');
      document.addEventListener('keydown', onKey);
      var first = (auto === true ? closeBtn : null) || modal.querySelector('input[type="email"]') || closeBtn;
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('f-offer-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    openBtn.addEventListener('click', function () { open(false); });
    /* the side tab slides in once the visitor starts scrolling */
    function showTab() {
      if (window.scrollY < 80) return;
      openBtn.classList.add('is-shown'); openBtn.removeAttribute('tabindex'); openBtn.removeAttribute('aria-hidden');
      window.removeEventListener('scroll', showTab);
    }
    window.addEventListener('scroll', showTab, { passive: true });
    showTab();
    /* success state: copy the code */
    var copyBtn = modal.querySelector('[data-f-offer-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = (modal.querySelector('[data-f-offer-code]') || {}).textContent || '';
      try { navigator.clipboard.writeText(code.trim()); copyBtn.textContent = 'Copied'; } catch (e) {}
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('mousedown', function (e) { if (e.target === modal) close(); });
    if (location.hash === '#f-offer-form' && modal.querySelector('[role="status"], [role="alert"]')) { openBtn.classList.add('is-shown'); open(false); markSeen(); return; }

    /* Pop the offer once, shortly after the visitor starts scrolling (not again for 7 days). */
    var KEY = 'f-offer-seen';
    var WEEK = 7 * 24 * 60 * 60 * 1000;
    function alreadySeen() {
      try { var t = parseInt(localStorage.getItem(KEY), 10); return t && Date.now() - t < WEEK; } catch (e) { return false; }
    }
    function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    closeBtn && closeBtn.addEventListener('click', markSeen);
    var skip = /^\/(cart|account|checkouts)/.test(location.pathname) || (window.Shopify && window.Shopify.designMode);
    if (skip || alreadySeen()) return;
    /* Pop the offer a few seconds into the visit (not over the fit finder popup; retry a bit later if it's open). */
    /* don't pop over someone mid-task: typing, choosing a size, or a tap/key in the last 3 s */
    var lastInput = 0;
    ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { lastInput = Date.now(); }, { passive: true, capture: true }); });
    function busy() {
      var a = document.activeElement;
      if (Date.now() - lastInput < 3000) return true;
      if (a && a !== document.body && a.matches && a.matches('input, select, textarea')) return true;
      var q = document.querySelector('iframe[src*="perfect-product-finder"]');
      var fq = document.getElementById('f-quiz-host');
      return (q && q.offsetParent !== null) || (fq && fq.shadowRoot && fq.shadowRoot.querySelector('.quiz.on, .quiz:not([hidden])') && document.documentElement.classList.contains('f-quiz-open'));
    }
    function autoOpen() {
      if (!modal.hidden) return;
      if (busy()) { setTimeout(autoOpen, 4000); return; }
      markSeen();
      openBtn.classList.add('is-shown'); openBtn.removeAttribute('tabindex'); openBtn.removeAttribute('aria-hidden');
      open(true);
    }
    /* the 5 s count starts at the visitor's first scroll, tap or key press: popping it on load made it the page's
       largest paint on phones (LCP ~0.8 s -> 5.6 s on the shop page) */
    var armed = false;
    function arm() {
      if (armed) return; armed = true;
      ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (t) { window.removeEventListener(t, arm, true); });
      setTimeout(autoOpen, 5000);
    }
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (t) { window.addEventListener(t, arm, { passive: true, capture: true }); });
  }

  /* ---- Nav dropdown: hover/focus handled in CSS; button toggles for touch + keyboard ---- */
  function initNav(root) {
    var items = root.querySelectorAll('[data-f-nav-item]');
    if (!items.length) return;
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var b = it.querySelector('.f-nav__toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (it) {
      var btn = it.querySelector('.f-nav__toggle');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !it.classList.contains('is-open');
        closeAll(it);
        it.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-f-nav-item]')) closeAll(); });
    items.forEach(function (it) {
      it.addEventListener('focusout', function (e) { if (!e.relatedTarget || !it.contains(e.relatedTarget)) closeAll(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = root.querySelector('[data-f-nav-item].is-open');
      closeAll();
      if (open) { var b = open.querySelector('.f-nav__toggle'); if (b) b.focus(); }
    });
  }

  /* ---- Phone menu: three-line button opens a full-screen panel; columns slide in as their own lists ---- */
  function initMobileNav(header) {
    var btn = header.querySelector('[data-f-mnav-toggle]');
    var nav = document.getElementById('f-mnav');
    if (!btn || !nav) return;
    var root = nav.querySelector('[data-f-mnav-panel="root"]');
    var html = document.documentElement;
    function show(panel) {
      nav.querySelectorAll('[data-f-mnav-panel]').forEach(function (p) {
        if (p === root) return;
        p.hidden = p !== panel;
      });
      root.classList.toggle('is-behind', panel !== root);
      root.setAttribute('aria-hidden', panel !== root ? 'true' : 'false');
      panel.scrollTop = 0;
    }
    function setOpen(open) {
      if (open) {
        var r = header.getBoundingClientRect();
        nav.style.setProperty('--f-mnav-top', Math.max(0, Math.round(r.bottom)) + 'px');
        show(root);
      }
      nav.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      html.classList.toggle('f-mnav-open', open);
    }
    btn.addEventListener('click', function () { setOpen(nav.hidden); });
    nav.addEventListener('click', function (e) {
      var go = e.target.closest('[data-f-mnav-go]');
      if (go) {
        var panel = document.getElementById('f-mnav-' + go.getAttribute('data-f-mnav-go'));
        if (panel) {
          show(panel);
          var back = panel.querySelector('[data-f-mnav-back]');
          if (back) back.focus({ preventScroll: true });
        }
        return;
      }
      if (e.target.closest('[data-f-mnav-back]')) {
        var from = e.target.closest('[data-f-mnav-panel]');
        show(root);
        var opener = from && root.querySelector('[data-f-mnav-go="' + from.getAttribute('data-f-mnav-panel') + '"]');
        if (opener) opener.focus({ preventScroll: true });
        return;
      }
      /* any link: close (hash links such as the fit finder open a popup on this same page) */
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !nav.hidden) { setOpen(false); btn.focus(); }
    });
    var mq = window.matchMedia('(max-width: 640px)');
    var onMq = function () { if (!mq.matches && !nav.hidden) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }

  /* ---- Product gallery: thumbnails swap the main image + the callouts laid over it ---- */
  function initGallery(root) {
    var main = root.querySelector('[data-f-gallery-main]');
    var frame = root.querySelector('[data-f-gallery-frame]');
    var thumbs = root.querySelectorAll('[data-f-gallery-thumb]');
    var callouts = root.querySelectorAll('[data-f-co]:not([data-f-gallery-thumb])');
    if (!main) return;
    function showCallouts(co) {
      callouts.forEach(function (c) { c.hidden = c.getAttribute('data-f-co') !== co; });
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.removeAttribute('srcset');   /* the first image ships a srcset; thumbnails swap in a single src */
        main.src = btn.getAttribute('data-src');
        main.alt = btn.getAttribute('data-alt') || main.alt;
        if (frame) frame.setAttribute('data-f-view', btn.getAttribute('data-f-view') || 'photo');
        showCallouts(btn.getAttribute('data-f-co'));
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      });
    });
    /* phones: swipe the main image to step through the thumbnails */
    var x0 = null, y0 = 0;
    (frame || main).addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    (frame || main).addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var list = [].slice.call(thumbs), i = list.findIndex(function (t) { return t.classList.contains('is-active'); });
      var next = list[(Math.max(i, 0) + (dx < 0 ? 1 : list.length - 1)) % list.length];
      if (next) next.click();
    }, { passive: true });
  }

  /* ---- Size picker: single select, note text, Add to bag requires a size ---- */
  function initSizes(root) {
    var form = root.querySelector('[data-f-product-form]');
    if (!form) return;
    var select = form.querySelector('[data-f-size-select]');
    var note = form.querySelector('[data-f-size-note]');
    var err = form.querySelector('[data-f-size-error]');
    var price = root.querySelector('[data-f-price-amount]');
    var defaultNote = note ? note.textContent : '';
    var idInput = form.querySelector('[data-f-size-id]');
    function picked() { return select && select.value ? select.options[select.selectedIndex] : null; }
    function sync() {
      var o = picked();
      if (!o) return;
      if (idInput) { idInput.value = o.value; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (err) err.textContent = '';
      if (select) select.classList.remove('is-invalid');
      if (note) note.textContent = 'Selected: ' + o.getAttribute('data-label') + '. Trim the toe with scissors if you need to.';
      if (price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
      var bp = form.querySelector('[data-f-btn-price]');
      if (bp && o.getAttribute('data-price')) bp.textContent = ' \u00b7 ' + o.getAttribute('data-price');
    }
    if (select) { select.addEventListener('change', sync); sync(); }   /* sync() covers a ?variant= preselect */
    /* Owner, 2026-10-01: once a size is chosen, Add to bag flashes to draw the eye (CSS .is-flash; off for reduced motion). */
    var addBtn = form.querySelector('button[type="submit"]');
    if (select && addBtn) select.addEventListener('change', function () {
      if (!picked() || addBtn.disabled) return;
      addBtn.classList.remove('is-flash');
      void addBtn.offsetWidth;   /* restart the animation if the size is changed again */
      addBtn.classList.add('is-flash');
    });
    if (addBtn) addBtn.addEventListener('animationend', function () { addBtn.classList.remove('is-flash'); });
    form.setAttribute('novalidate', '');
    function needSize(e) {
      if (select && !picked()) {
        e.preventDefault();
        e.stopPropagation();
        if (err) err.textContent = 'Please choose your size.';
        if (note) note.textContent = defaultNote;
        select.classList.add('is-invalid');
        select.focus({ preventScroll: true });
        select.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return true;
      }
      return false;
    }
    form.addEventListener('submit', needSize);
    /* Added-to-bag panel (owner, 2026-10-06): the split test showed shoppers dropping off between the bag and checkout, and the
       old site keeps them on the product page with a Checkout button one tap away. So Add to bag adds by fetch and opens a
       panel (item, Checkout, View bag) instead of loading /cart. Any failure falls back to the normal form post (-> /cart). */
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented || !window.fetch || !window.FormData) return;   /* needSize() already stopped it */
      e.preventDefault();
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-busy'); }
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-busy'); }
          if (!res.ok) { if (err) err.textContent = (res.j && (res.j.description || res.j.message)) || 'That size could not be added. Please try again.'; return; }
          showAdded(res.j, addBtn);
          setTimeout(tagSiteVersion, 300);
        })
        .catch(function () { if (addBtn) addBtn.disabled = false; HTMLFormElement.prototype.submit.call(form); });
    });
    /* Opinew's review widget installs a window keydown "focus trap" for its hidden write-a-review form and swallows every
       Tab once a size is picked (keyboard shoppers couldn't reach Add to bag; same on the old theme). Let Tab through
       unless that form is actually open or one of our dialogs owns the keyboard. */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || document.documentElement.classList.contains('f-offer-open')) return;
      var a = document.activeElement;
      if (a && a.closest && a.closest('[role="dialog"], [aria-modal="true"], .opw-review-form-container')) return;
      var rf = document.querySelector('.opw-review-form-container');
      if (rf && rf.offsetParent) return;
      e.stopImmediatePropagation();
    }, true);
    /* Express checkout (Apple Pay / Shop Pay / Buy it now) also needs a size; catch it before Shopify's script does. */
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.shopify-payment-button')) needSize(e);
    }, true);
  }

  /* ---- Shop: single-select filter chips with a live count ---- */
  function initShop(root) {
    var chips = root.querySelectorAll('[data-f-filter]');
    var cards = root.querySelectorAll('.f-pcard');
    var count = root.querySelector('[data-f-count]');
    var empty = root.querySelector('[data-f-empty]');
    if (!chips.length) return;
    function apply(key) {
      var n = 0;
      cards.forEach(function (c) {
        var tags = (c.getAttribute('data-f-tags') || '').split(' ');
        var show = key === 'all' || tags.indexOf(key) !== -1;
        c.hidden = !show;
        if (show) n++;
      });
      chips.forEach(function (b) {
        var on = b.getAttribute('data-f-filter') === key;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (count) count.textContent = n === cards.length ? 'Showing all ' + cards.length : 'Showing ' + n + ' of ' + cards.length;
      if (empty) empty.hidden = n !== 0;
    }
    chips.forEach(function (b) {
      var key = b.getAttribute('data-f-filter');
      if (key !== 'all') {
        var hits = [].filter.call(cards, function (c) { return (c.getAttribute('data-f-tags') || '').split(' ').indexOf(key) !== -1; }).length;
        if (!hits || hits === cards.length) { b.hidden = true; return; }   /* no dead-end chips ("Showing 0 of 3") or chips that change nothing */
      }
      b.addEventListener('click', function () { apply(key); });
    });
    /* Only "All" left: drop the whole chip row. */
    var bar = root.querySelector('.f-filter');
    if (bar && ![].some.call(chips, function (b) { return !b.hidden && b.getAttribute('data-f-filter') !== 'all'; })) {
      [].forEach.call(bar.children, function (el) { if (!el.hasAttribute('data-f-count')) el.hidden = true; });
    }
  }

  /* ---- Best sellers: scroll-snap row, prev/next buttons, progress bar ---- */
  function initBestSellers(root) {
    var row = root.querySelector('[data-f-bs-row]');
    var prev = root.querySelector('[data-f-bs-prev]');
    var next = root.querySelector('[data-f-bs-next]');
    var thumb = root.querySelector('[data-f-bs-thumb]');
    if (!row) return;
    function cardStep() {
      var card = row.querySelector('.f-pcard');
      if (!card) return row.clientWidth;
      var style = getComputedStyle(row);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function updateBar() {
      if (!thumb) return;
      var max = row.scrollWidth - row.clientWidth;
      var visibleFraction = max > 0 ? row.clientWidth / row.scrollWidth : 1;
      var scrolledFraction = max > 0 ? row.scrollLeft / max : 0;
      thumb.style.width = (visibleFraction * 100) + '%';
      thumb.style.transform = 'translateX(' + (scrolledFraction * (100 / visibleFraction - 100)) + '%)';
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= max - 2;
    }
    var behavior = reduceMotion ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -cardStep(), behavior: behavior }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: cardStep(), behavior: behavior }); });
    row.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  }

  /* ---- Announcement bar: one message at a time, arrows, 4.5s auto-advance, pauses on hover/focus ---- */
  function initAnnounce(bar) {
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-f-announce-msg]'));
    if (msgs.length < 2) return;
    var prevBtn = bar.querySelector('[data-f-announce-prev]');
    var nextBtn = bar.querySelector('[data-f-announce-next]');
    var index = 0;
    var timer = null;
    var paused = false;

    function show(n, dir) {
      var old = msgs[index];
      index = (n + msgs.length) % msgs.length;
      var cur = msgs[index];
      if (cur === old) return;
      msgs.forEach(function (m) { m.classList.remove('is-leaving-up', 'is-leaving-down'); });
      if (!reduceMotion) {
        /* new message starts 10px on the far side of its travel, then eases in */
        cur.style.transition = 'none';
        cur.style.transform = 'translateY(' + (dir < 0 ? '-10px' : '10px') + ')';
        void cur.offsetWidth;
        cur.style.transition = '';
        cur.style.transform = '';
        old.classList.add(dir < 0 ? 'is-leaving-down' : 'is-leaving-up');
      }
      old.classList.remove('is-active');
      old.setAttribute('aria-hidden', 'true');
      old.setAttribute('tabindex', '-1');
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.removeAttribute('tabindex');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!reduceMotion && !paused) timer = setInterval(function () { show(index + 1, 1); }, 4500);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1, -1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1, 1); start(); });
    bar.addEventListener('mouseenter', function () { paused = true; stop(); });
    bar.addEventListener('mouseleave', function () { paused = false; start(); });
    bar.addEventListener('focusin', function () { paused = true; stop(); });
    bar.addEventListener('focusout', function () { paused = false; start(); });
    start();
  }

  /* ---- Product features explorer: hotspots + prev/next choose the active feature ---- */
  function initFeatures(root) {
    var spots = root.querySelectorAll('[data-f-hs]');
    var items = root.querySelectorAll('[data-f-feat-item]');
    var prev = root.querySelector('[data-f-feat-prev]');
    var next = root.querySelector('[data-f-feat-next]');
    if (!spots.length || !items.length) return;
    var index = 0;
    function show(n) {
      index = (n + items.length) % items.length;
      items.forEach(function (el, i) { el.hidden = i !== index; });
      spots.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
    }
    spots.forEach(function (el, i) { el.addEventListener('click', function () { show(i); }); });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
  }

  /* ---- FAQ / collapsible rows: a plain, reliable toggle.
     The stock slide animation could get stuck on some pages (row opens, snaps shut, re-opens ~2s later), so
     this capture-phase handler takes over the row buttons before the theme's own handler sees the click. ---- */
  function initRows() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.collapsible-row-list-item__trigger');
      if (!btn) return;
      var content = btn.nextElementSibling;
      if (!content) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      function set(b, c, open) {
        if (!c) return;
        c.removeAttribute('style');
        c.style.display = open ? 'block' : 'none';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        c.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (b.parentNode) b.parentNode.setAttribute('data-open', open ? 'true' : 'false');
      }
      var opening = btn.getAttribute('aria-expanded') !== 'true';
      var section = btn.closest('[data-section-type="collapsible-row-list"]');
      if (opening && section && section.getAttribute('data-auto-collapse') === 'true') {
        section.querySelectorAll('.collapsible-row-list-item__trigger[aria-expanded="true"]').forEach(function (other) {
          if (other !== btn) set(other, other.nextElementSibling, false);
        });
      }
      set(btn, content, opening);
    }, true);
  }

  /* ---- Videos: every video gets a visible play button that opens it in a lightbox with sound + controls.
     - .f-vid buttons (sections/form-video.liquid) carry data-mp4 / data-embed.
     - Older looping, muted, controls-less clips (video-with-text, video-hero) get a play button injected. ---- */
  var lightbox = null;
  function closeLightbox() {
    if (!lightbox) return;
    var v = lightbox.querySelector('video');
    if (v) v.pause();
    lightbox.remove();
    lightbox = null;
    document.removeEventListener('keydown', lightboxKey);
    if (lightbox_last && lightbox_last.focus) lightbox_last.focus();
  }
  var lightbox_last = null;
  function lightboxKey(e) { if (e.key === 'Escape') closeLightbox(); }
  function openLightbox(opts) {
    closeLightbox();
    lightbox_last = document.activeElement;
    var box = document.createElement('div');
    box.className = 'f-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Video');
    var inner = document.createElement('div');
    inner.className = 'f-lightbox__inner';
    if (opts.mp4) {
      var v = document.createElement('video');
      v.src = opts.mp4; v.controls = true; v.autoplay = true; v.playsInline = true;
      inner.appendChild(v);
    } else if (opts.embed) {
      var parts = opts.embed.split(':');
      var f = document.createElement('iframe');
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.title = 'Video';
      f.src = parts[0] === 'vimeo' ? 'https://player.vimeo.com/video/' + parts[1] + '?autoplay=1' : 'https://www.youtube.com/embed/' + parts[1] + '?autoplay=1&rel=0&playsinline=1';
      inner.appendChild(f);
    }
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'f-lightbox__close'; x.setAttribute('aria-label', 'Close video'); x.innerHTML = '&times;';
    x.addEventListener('click', closeLightbox);
    box.appendChild(inner); box.appendChild(x);
    box.addEventListener('mousedown', function (e) { if (e.target === box) closeLightbox(); });
    document.body.appendChild(box);
    lightbox = box;
    document.addEventListener('keydown', lightboxKey);
    x.focus();
  }
  function decorateClip(video) {
    if (video.getAttribute('data-f-vplay')) return;
    var src = video.currentSrc || video.src || (video.querySelector('source') || {}).src;
    if (!src || video.controls) return;
    var host = video.parentElement;
    if (!host) return;
    video.setAttribute('data-f-vplay', '1');
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'f-vplay'; b.setAttribute('aria-label', 'Play video with sound');
    b.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"></path></svg>';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openLightbox({ mp4: video.currentSrc || video.src || src }); });
    host.appendChild(b);
  }
  function scanClips() {
    document.querySelectorAll('.video-with-text__video, .video-hero__video').forEach(decorateClip);
  }
  function initVideos() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-f-video-open]');
      if (!btn) return;
      openLightbox({ mp4: btn.getAttribute('data-mp4'), embed: btn.getAttribute('data-embed') });
    });
    scanClips();
    /* the theme inserts these <video> tags from a template after load, so watch for them */
    if (window.MutationObserver) {
      new MutationObserver(scanClips).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- Fit finder: every fit-finder link opens ONE quiz, picked in Theme settings > FORM fit finder (data-engine).
     "lantern": links point at Lantern's popup (#open-quiz-tools/perfect-product-finder/<slug>) and the FORM quiz never loads.
     "form": links open the full-screen FORM quiz (assets/form-quiz.js, loaded on first use); if that script can't load,
     the link falls back to its original target. ?quiz=form previews the FORM quiz in either mode. ---- */
  function initQuiz() {
    var host = document.querySelector('[data-f-quiz]');
    if (!host) return;
    if ((host.getAttribute('data-engine') || 'lantern') === 'lantern' && !/[?&]quiz=form\b/.test(location.search)) {
      initLantern(host.getAttribute('data-lantern') || 'insole-fit-finder');
      return;
    }
    var loading = false;
    function open(src, fallbackHref) {
      if (window.FormQuiz) { window.FormQuiz.open(src); return; }
      if (loading) return;
      loading = true;
      var s = document.createElement('script');
      s.src = host.getAttribute('data-js');
      s.onload = function () { loading = false; window.FormQuiz.open(src); };
      s.onerror = function () { loading = false; if (fallbackHref) window.location.href = fallbackHref; };
      document.head.appendChild(s);
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a, button');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.hasAttribute('data-f-quiz-open') || href.indexOf('open-quiz-tools') > -1 || href === '#fit-finder' || /[#]fit-finder$/.test(href)) {
        e.preventDefault();
        e.stopPropagation();
        open(a.getAttribute('data-f-quiz-src') || (a.closest('[data-f-header]') ? 'header' : (a.closest('.f-announce') ? 'announcement' : 'link')), href.charAt(0) === '#' ? location.pathname + href : href);
      }
    }, true);
    if (location.hash === '#fit-finder' || /[?&]quiz=(1|open|form)\b/.test(location.search)) open('url', '');
  }

  /* ---- Lantern quiz analytics (owner, 2026-10-01). Same event names as the FORM quiz (form_quiz_*, docs/quiz-tracking.md)
     with quiz = lantern-fit-finder, so one GA4 dashboard covers either engine. Sent to GTM (dataLayer), GA4 (gtag),
     Clarity and Shopify customer events, only with analytics consent. No email, name or weight number is sent.
     Anything off the published theme (previews, staging) is tagged quiz_test = yes so it can be filtered out. ---- */
  var LQ = { sid: '', source: '', open: false, done: false, last: '', steps: {}, answers: {}, results: '' };
  function lqConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed(); } catch (e) {}
    return true;
  }
  function lqTrack(name, data) {
    if (!LQ.sid) LQ.sid = Math.random().toString(36).slice(2, 10);
    var p = { quiz: 'lantern-fit-finder', quiz_session: LQ.sid };
    if (LQ.source) p.quiz_source = LQ.source;
    var th = window.Shopify && window.Shopify.theme;
    if (/[?&]quizdebug=1\b/.test(location.search) || (th && th.role && th.role !== 'main')) p.quiz_test = 'yes';
    Object.keys(data || {}).forEach(function (k) {
      var v = data[k];
      if (v === undefined || v === null || v === '') return;
      if (typeof v === 'boolean') v = v ? 'yes' : 'no';
      if (typeof v === 'string' && v.length > 100) v = v.slice(0, 100);
      p[k] = v;
    });
    var ev = 'form_quiz_' + name;
    if (/[?&]quizdebug=1\b/.test(location.search)) { try { console.log('[quiz]', ev, p); } catch (e) {} }
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p)); } catch (e) {}
    if (!lqConsent()) return;
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', ev); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(ev, p); } catch (e) {}
  }
  function lqOpen(source) {
    if (LQ.open) return;
    LQ = { sid: Math.random().toString(36).slice(2, 10), source: source || 'link', open: true, done: false, last: '', steps: {}, answers: {}, results: '' };
    lqTrack('open', { device: window.innerWidth >= 900 ? 'large' : 'small' });
  }
  /* question title -> the same step names as the FORM quiz */
  function lqStep(title) {
    var t = String(title || '').toLowerCase();
    if (/use them for/.test(t)) return 'activity';
    if (/on the job|shoes will you|kind of boots|train in|which sport/.test(t)) return 'shoe_type';
    if (/pain|concern/.test(t)) return 'concern';
    if (/weigh/.test(t)) return 'weight';
    if (/men.s or women/.test(t)) return 'sizing';
    if (/shoe size/.test(t)) return 'size';
    return t.slice(0, 40);
  }
  window.addEventListener('pagehide', function () {
    if (LQ.open && !LQ.done) lqTrack('abandon', { last_step: LQ.last });
  });
  /* is this quiz root on screen? (the popup is a same-origin iframe that Lantern hides on close) */
  function lqVisible(root) {
    try {
      var fe = root.host.ownerDocument.defaultView.frameElement;
      if (!fe) return true;   /* standalone quiz page */
      var r = fe.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && fe.offsetParent !== null && getComputedStyle(fe).visibility !== 'hidden';
    } catch (e) { return true; }
  }
  /* close: Lantern's X sits outside the quiz's shadow root, so watch for the popup going away instead */
  setInterval(function () {
    if (!LQ.open || document.getElementById('perfect-product-finder')) return;
    var shown = [].some.call(document.querySelectorAll('iframe[src*="perfect-product-finder"]'), function (f) {
      var r = f.getBoundingClientRect(); return r.width > 0 && r.height > 0 && f.offsetParent !== null && getComputedStyle(f).visibility !== 'hidden';
    });
    if (shown) { LQ.seenFrame = true; return; }
    /* only once the popup has actually been on screen: right after a click it takes a moment to appear */
    if (LQ.seenFrame) { lqTrack('close', { last_step: LQ.last, completed: LQ.done }); LQ.open = false; LQ.closedOn = LQ.last; }
  }, 1000);
  /* quiz cart attributes, saved at Add to bag, applied once the cart holds something (see lqCart) */
  function lqApplyAttrs() {
    var raw; try { raw = sessionStorage.getItem('f_quiz_attrs'); } catch (e) { return; }
    if (!raw || !window.fetch) return;
    var a; try { a = JSON.parse(raw); } catch (e) { return; }
    if (!a || Date.now() - (a.t || 0) > 3 * 60 * 60 * 1000) { try { sessionStorage.removeItem('f_quiz_attrs'); } catch (e) {} return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) return;   /* not in the cart yet: try again on the next page */
      delete a.t;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) })
        .then(function (r) { if (r.ok) { try { sessionStorage.removeItem('f_quiz_attrs'); } catch (e) {} } });
    }).catch(function () {});
  }

  /* Lantern mode: send every fit-finder link to the chosen Lantern quiz (older links name the old quiz's slug). */
  function initLantern(slug) {
    var hash = '#open-quiz-tools/perfect-product-finder/' + slug;
    function fix(a) {
      var href = a.getAttribute('href') || '';
      if (href === '#fit-finder' || /#fit-finder$/.test(href)) a.setAttribute('href', hash);
      else if (href.indexOf('open-quiz-tools/perfect-product-finder/') > -1) a.setAttribute('href', href.replace(/open-quiz-tools\/perfect-product-finder\/[^?#\s]*/, hash.slice(1)));
    }
    document.querySelectorAll('a[href*="open-quiz-tools"], a[href$="#fit-finder"]').forEach(fix);
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('a, [data-f-quiz-open]');
      if (!el) return;
      if (el.tagName === 'A') fix(el);
      else { e.preventDefault(); location.hash = hash.slice(1); }
      if (el.tagName !== 'A' || (el.getAttribute('href') || '').indexOf('open-quiz-tools') > -1) {
        lqOpen(el.getAttribute('data-f-quiz-src') || (el.closest('[data-f-header], .f-mnav') ? 'header' : (el.closest('.f-announce') ? 'announcement' : 'link')));
      }
    }, true);
    /* Deep links (/#fit-finder, ?quiz=1, or a pasted #open-quiz-tools/... URL): Lantern only opens on a click, not on a
       hash that's already there at load, so clear the hash and click a link to it once Lantern's script is up. */
    if (location.hash === '#fit-finder' || location.hash.indexOf('#open-quiz-tools/') === 0 || /[?&]quiz=(1|open)\b/.test(location.search)) {
      var tries = 0;
      var go = function () {
        if (document.querySelector('iframe[src*="perfect-product-finder"]')) return;
        if (location.hash) history.replaceState(null, '', location.pathname + location.search);
        var a = document.createElement('a');
        a.href = hash; a.hidden = true;
        if (!tries) lqOpen('url');
        document.body.appendChild(a); a.click(); a.remove();
        if (++tries < 8) setTimeout(go, 1200);
      };
      if (document.readyState === 'complete') setTimeout(go, 600); else window.addEventListener('load', function () { setTimeout(go, 600); });
    }
    initLanternSizes();
  }

  /* Lantern size helper. The Lantern quiz asks for a US size (men's answers "9 – 9.5", women's "9.5 – 10").
     Lantern can't pre-select a variant, so we remember that answer and pick the matching size in each result
     card's variant dropdown, once per card (the shopper can still change it). Women's 7.5+ share the men's
     insole 1.5 sizes down, the same rule as the product variant names ("Men's 6-6.5 / Women's 7.5-8"). */
  function initLanternSizes() {
    var KEY = 'f_lantern_size', seen = [];
    var setValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    /* localStorage: Lantern reopens returning shoppers straight on their results, so the size must survive a new visit */
    function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function load() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function norm(t) { return String(t).toLowerCase().replace(/women'?s?/g, 'w').replace(/men'?s?/g, 'm').replace(/[^a-z0-9.\-\/]/g, ''); }
    function target(code) {
      var n = parseFloat(code.slice(1));
      if (code.charAt(0) === 'w' && n <= 7) return 'w' + n + '-' + (n + 0.5);
      if (code.charAt(0) === 'w') n = n - 1.5;
      return 'm' + n + '-' + n + '.5';
    }
    var stockCache = {};
    function stock(handle, cb) {
      if (!stockCache[handle]) stockCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.variants || []; }).catch(function () { return []; });
      stockCache[handle].then(cb);
    }
    function apply(root) {
      var code = load();
      if (!code) return;
      var want = target(code);
      root.querySelectorAll('select.variant-selector').forEach(function (sel) {
        if (sel.getAttribute('data-f-sized') === code) return;
        sel.setAttribute('data-f-sized', code);
        var opt = [].filter.call(sel.options, function (o) { return norm(o.text).indexOf(want) === 0; })[0];
        /* not made in that size (Thin-Fit/Narrow stop at M13, only they go down to W4.5) or sold out: leave the
           dropdown alone, say so, and make the shopper pick a size before Add to bag (see guard below) */
        var state = !opt ? 'none' : (opt.disabled || /sold ?out|unavailable/i.test(opt.text) ? 'soldout' : 'ok');
        sel.setAttribute('data-f-size-state', state);
        if (state !== 'ok') return;
        /* Lantern lists sold-out sizes as normal options: check real stock and flag it (the Add to bag guard then waits) */
        var card = sel.closest('.product-card'), link = card && card.querySelector('a[href*="/products/"]');
        var hm = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (hm) stock(hm[1], function (vs) {
          var v = vs.filter(function (x) { return norm(x.title).indexOf(want) === 0; })[0];
          if (v && !v.available && sel.getAttribute('data-f-size-state') === 'ok') { sel.setAttribute('data-f-size-state', 'soldout'); labels(root); }
        });
        if (sel.value === opt.value) return;
        setValue.call(sel, opt.value);
        sel.dispatchEvent(new (sel.ownerDocument.defaultView || window).Event('change', { bubbles: true }));
      });
    }
    /* Insole facts on each result card (thickness, arch, best for, fits best in, plus a "Your size" label over the
       dropdown). Same data as the product pages: snippets/form-quiz.liquid -> #f-quiz-data (from snippets/form-model.liquid). */
    var facts = null;
    try {
      var qd = JSON.parse((document.getElementById('f-quiz-data') || {}).textContent || '{}');
      facts = {};
      Object.keys(qd.products || {}).forEach(function (k) { var p = qd.products[k]; facts[p.handle] = p; });
    } catch (e) { facts = null; }
    var THICK = ['Thin', 'Medium', 'Thick'], ARCH = ['Low', 'Medium', 'High'];
    var INFO_CSS = '.f-qi{margin:14px 0 16px;display:grid;gap:12px}' +
      '.f-qi__specs{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
      '.f-qi__spec{background:#f7f5f0;border-radius:12px;padding:10px 12px}' +
      '.f-qi__spec span{display:block;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#6b655e}' +
      '.f-qi__spec b{display:block;margin-top:3px;font-size:15px;font-weight:800;color:#1e1e1e}' +
      '.f-qi__list{list-style:none;margin:0;padding:0;display:grid;gap:8px}' +
      '.f-qi__list li{position:relative;padding-left:26px;font-size:14px;line-height:1.45;color:#41464c}' +
      '.f-qi__list li::before{content:"";position:absolute;left:0;top:2px;width:17px;height:17px;border-radius:50%;background:#e3001b url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M5 12l5 5 9-10%27/%3E%3C/svg%3E") center/11px no-repeat}' +
      '.f-qi__list b{color:#1e1e1e}' +
      '.f-qi__size{margin:2px 0 -6px;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#6b655e}' +
      '.f-qi__size.is-warn{letter-spacing:0;text-transform:none;font-size:13px;line-height:1.4;color:#c20017}' +
      '.f-qi__size.is-shake{animation:fqishake .35s}@keyframes fqishake{25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}';
    var SIZE_MSG = { none: 'This insole isn\u2019t made in your size. Pick the closest size below.', soldout: 'Your size is sold out in this insole. Pick another size below.' };
    /* label over each card's size dropdown: "Your size", or why the size isn't preselected */
    function labels(root) {
      root.querySelectorAll('.product-card').forEach(function (card) {
        var lab = card.querySelector('.f-qi__size'), sel = card.querySelector('select.variant-selector');
        if (!lab || !sel) return;
        var st = sel.getAttribute('data-f-size-state'), warn = !!SIZE_MSG[st] && !sel.hasAttribute('data-f-chosen');
        var txt = warn ? SIZE_MSG[st] : (st ? 'Your size' : 'Size');
        /* only write when it changes: a write is a DOM mutation, which re-runs this from the observer (was a 30/s loop) */
        if (lab.textContent !== txt) lab.textContent = txt;
        if (lab.classList.contains('is-warn') !== warn) lab.classList.toggle('is-warn', warn);
      });
    }
    /* Add to bag on a card whose size we couldn't preselect: stop it until the shopper picks a size themselves
       (otherwise the dropdown's first variant, e.g. Women's 4.5-5, goes in the bag) */
    function guard(root) {
      if (root.__fGuard) return;
      root.__fGuard = true;
      root.addEventListener('change', function (e) {
        if (e.isTrusted && e.target.matches && e.target.matches('select.variant-selector')) { e.target.setAttribute('data-f-chosen', ''); labels(root); }
      }, true);
      root.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.add-to-cart-button');
        var card = btn && btn.closest('.product-card'), sel = card && card.querySelector('select.variant-selector');
        if (!sel || !SIZE_MSG[sel.getAttribute('data-f-size-state')] || sel.hasAttribute('data-f-chosen')) return;
        e.preventDefault(); e.stopPropagation();
        var lab = card.querySelector('.f-qi__size');
        if (lab) { lab.classList.remove('is-shake'); void lab.offsetWidth; lab.classList.add('is-shake'); }
        sel.focus();
      }, true);
    }
    /* analytics: which question is on screen, and the results once they show */
    function lqScan(root) {
      if (!lqVisible(root)) return;   /* a closed (hidden) popup keeps its last screen in the page */
      var q = root.querySelector('form.question-form .question h2');
      if (q) {
        var step = lqStep(q.textContent);
        root.__lqResults = '';
        if (!LQ.open) lqOpen('link');
        LQ.last = step;
        if (!LQ.steps[step]) { LQ.steps[step] = 1; lqTrack('step_view', { step: step, step_index: Object.keys(LQ.steps).length }); }
        return;
      }
      var cards = root.querySelectorAll('.product-card');
      if (!cards.length || !root.querySelector('.results-section, .location-results')) return;
      var hs = [].map.call(cards, function (c) {
        var a = c.querySelector('a[href*="/products/"]'), m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        return m ? m[1] : '';
      });
      var key = hs.join(',');
      if (!key || root.__lqResults === key) return;   /* counted once per popup per result set */
      root.__lqResults = key;
      var returning = LQ.lastResults === key;
      LQ.lastResults = key;
      if (!LQ.open) lqOpen('returning');
      LQ.results = key; LQ.done = true; LQ.last = 'results';
      lqTrack('results_view', {
        returning: returning,
        top_pick: hs[0], alternative: hs[1], activity: LQ.answers.activity, shoe: LQ.answers.shoe_type,
        concerns: LQ.answers.concern, weight_band: LQ.answers.weight, size_asked: LQ.answers.size ? 'yes' : 'no'
      });
    }
    /* analytics + order attribution: Add to bag from a result card (after the size guard, which may block it) */
    function lqCart(root) {
      if (root.__fLqCart) return;
      root.__fLqCart = true;
      root.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.add-to-cart-button');
        var card = btn && btn.closest('.product-card');
        if (!card) return;
        var a = card.querySelector('a[href*="/products/"]'), m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        var handle = m ? m[1] : '', sel = card.querySelector('select.variant-selector');
        if (e.defaultPrevented) { lqTrack('add_blocked_no_size', { product: handle }); return; }
        var cardsAll = root.querySelectorAll('.product-card');
        lqTrack('add_to_bag', { product: handle, variant_id: sel ? sel.value : '', is_top_pick: cardsAll[0] === card });
        /* cart attributes show on the order in Shopify admin (Additional details), so quiz orders can be counted there too.
           Not sent alongside Lantern's own add-to-cart: on a brand-new cart the two requests raced and the bag could come
           out empty. Saved instead and applied once the cart has the item (here a few seconds later, or on the next page). */
        try { sessionStorage.setItem('f_quiz_attrs', JSON.stringify({ quiz: 'lantern-fit-finder', quiz_session: LQ.sid, quiz_top_pick: (root.__lqResults || '').split(',')[0], t: Date.now() })); } catch (err) {}
        setTimeout(lqApplyAttrs, 3500);
      }, true);
    }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function addInfo(root) {
      if (!facts) return;
      if (!root.querySelector('style[data-f-qi]')) {
        var st = document.createElement('style');
        st.setAttribute('data-f-qi', '');
        st.textContent = INFO_CSS;
        root.appendChild(st);
      }
      root.querySelectorAll('.product-card').forEach(function (card) {
        if (card.querySelector('.f-qi')) return;
        var link = card.querySelector('a[href*="/products/"]'), sel = card.querySelector('select.variant-selector');
        if (!link || !sel) return;
        var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/), p = m && facts[m[1]];
        if (!p) return;
        var box = document.createElement('div');
        box.className = 'f-qi';
        box.innerHTML = '<div class="f-qi__specs">' +
            '<div class="f-qi__spec"><span>Cushion</span><b>' + THICK[p.thick] + (p.thickness ? ' \u00b7 ' + esc(p.thickness) : '') + '</b></div>' +
            '<div class="f-qi__spec"><span>Arch</span><b>' + (p.archmm ? 'Adaptive \u00b7 ' + esc(p.archmm) + ' mm' : 'All arch types') + '</b></div></div>' +
          '<ul class="f-qi__list"><li><b>Best for:</b> ' + esc(p.best) + '</li><li><b>Fits best in:</b> ' + esc(p.fits) + '</li></ul>' +
          '<div class="f-qi__size"></div>';
        /* insert just above the size dropdown's own wrapper inside the card */
        var at = sel;
        while (at.parentElement && at.parentElement !== card && !at.parentElement.querySelector('.product-details')) at = at.parentElement;
        at.parentElement.insertBefore(box, at);
      });
    }
    function watch(root) {
      if (seen.indexOf(root) > -1 || !window.MutationObserver) return;
      seen.push(root);
      var t;
      var mo = new MutationObserver(function () {
        if (!root.host || !root.host.isConnected) { mo.disconnect(); return; }   /* that popup is gone */
        clearTimeout(t); t = setTimeout(function () { apply(root); addInfo(root); labels(root); lqScan(root); }, 60);
      });
      mo.observe(root, { childList: true, subtree: true });
      guard(root);
      lqCart(root);
      lqScan(root);
      apply(root);
      addInfo(root);
      labels(root);
    }
    function onClick(e) {
      var path = e.composedPath ? e.composedPath() : [];
      var root = path[0] && path[0].getRootNode && path[0].getRootNode();
      if (!root || !root.host) return;   /* only clicks inside a shadow root (Lantern renders in one) */
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el.classList && el.classList.contains('answer')) {
          var t = (el.textContent || '').replace(/\s+/g, ' ').trim(), m;
          /* analytics: the answer's main label (first line), against the current question */
          var lab = el.querySelector('.answer-text-container > div');
          var q = root.querySelector('form.question-form .question h2');
          var step = lqStep(q && q.textContent);
          var ans = ((lab && lab.textContent) || t).replace(/\s+/g, ' ').trim();
          if (!LQ.open) lqOpen('link');
          LQ.answers[step] = ans;
          lqTrack('answer', { step: step, answer: ans });
          if ((m = t.match(/^(\d+) [–-] \1\.5$/))) save('m' + m[1]);
          else if ((m = t.match(/^(\d+\.5)(?: [–-] \d+)?$/))) save('w' + m[1]);
          else if (/choose my size later/i.test(t)) save('');
          break;
        }
      }
      /* Lantern's Close link: no class, just its text */
      var top = path[0];
      if (top && /^close$/i.test((top.textContent || '').trim()) && LQ.open) {
        lqTrack('close', { last_step: LQ.last, completed: LQ.done });
        LQ.open = false; LQ.closedOn = LQ.last;
      }
      watch(root);
    }
    /* the standalone quiz page (/tools/perfect-product-finder/...) runs this theme; the popup loads the same page
       in a same-origin iframe without it, so we reach into that iframe from here */
    function bind(doc) {
      if (!doc || doc.__fLantern) return;
      doc.__fLantern = true;
      doc.addEventListener('click', onClick, true);
      /* Lantern attaches its shadow root after load (and may reopen straight on saved results), so poll briefly */
      var tries = 0;
      (function find() {
        var host = doc.getElementById('perfect-product-finder');
        if (host && host.shadowRoot) { watch(host.shadowRoot); return; }
        if (++tries < 60) setTimeout(find, 250);
      })();
    }
    function bindFrame(f) {
      var go = function () { try { bind(f.contentDocument); } catch (e) {} };
      f.addEventListener('load', go);
      go();
    }
    bind(document);
    document.querySelectorAll('iframe[src*="perfect-product-finder"]').forEach(bindFrame);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          [].forEach.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return;
            if (n.tagName === 'IFRAME' && /perfect-product-finder/.test(n.src || '')) bindFrame(n);
            else if (n.querySelectorAll) n.querySelectorAll('iframe[src*="perfect-product-finder"]').forEach(bindFrame);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- "Chat with us" links ([data-f-chat]): open the Shopify Inbox chat; fall back to the link's own page ---- */
  function initChatLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-f-chat]');
      if (!a) return;
      var chat = document.querySelector('shopify-chat');
      if (!chat) return;
      try {
        /* Inbox has no public open() (its "open" is a state flag), so press its own launcher button */
        var btn = chat.shadowRoot && chat.shadowRoot.querySelector('button[part="activator"], button[aria-label="Open chat"]');
        /* capture phase + stopPropagation: Stiletto's page-transition handler navigates on any link click otherwise */
        if (btn) { e.preventDefault(); e.stopPropagation(); btn.click(); }
      } catch (err) {}
    }, true);
  }

  /* ---- Cart page +/- and Remove: sent through /cart/change.js. Shopify refuses a quantity above what it will sell
     (422, e.g. "You can only add 24 of this item"); a plain form post showed the browser's raw error page, so the
     message is shown on the line instead and "+" is disabled. The buttons still work as POST forms without JS. ---- */
  function initCartQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.f-cart__qbtn, .f-cart__remove');
      if (!b || b.disabled) return;
      var fa = b.getAttribute('formaction') || '';
      var m = fa.match(/[?&]id=([^&]+)&quantity=(\d+)/);
      if (!m || !window.fetch) return;
      e.preventDefault();
      var box = b.closest('.f-cart__qty'), info = b.closest('.f-cart__info') || box;
      var btns = box ? box.querySelectorAll('button') : [];
      [].forEach.call(btns, function (x) { x.disabled = true; });
      var old = info.querySelector('.f-cart__qerr'); if (old) old.remove();
      fetch(fa.split('?')[0] + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: decodeURIComponent(m[1]), quantity: parseInt(m[2], 10) })
      }).then(function (r) {
        if (r.ok) { location.reload(); return; }
        return r.json().catch(function () { return {}; }).then(function (j) {
          [].forEach.call(btns, function (x) { x.disabled = false; });
          if (/increase/i.test(b.getAttribute('aria-label') || '')) { b.disabled = true; b.title = 'That\u2019s all we have in this size'; }
          var p = document.createElement('p');
          p.className = 'f-cart__qerr'; p.setAttribute('role', 'alert');
          p.textContent = (j && (j.description || j.message)) || 'Sorry, we couldn\u2019t update that quantity.';
          info.appendChild(p);
        });
      }).catch(function () {
        [].forEach.call(btns, function (x) { x.disabled = false; });
        if (b.form && b.form.requestSubmit) b.form.requestSubmit(b);
      });
    }, true);
  }

  /* ---- Added-to-bag panel (see initSizes): desktop = card under the header, phone = bottom sheet. Checkout goes straight to
     Shopify checkout; View bag opens /cart. Closes on the X, Keep shopping, the backdrop (phone) or Escape. ---- */
  var addedEl = null, addedReturn = null;
  function addedClose() {
    if (!addedEl || addedEl.hidden) return;
    addedEl.hidden = true;
    document.documentElement.classList.remove('f-added-open');
    if (addedReturn && addedReturn.focus) addedReturn.focus({ preventScroll: true });
  }
  function showAdded(item, returnTo) {
    addedReturn = returnTo || null;
    if (!addedEl) {
      addedEl = document.createElement('div');
      addedEl.className = 'f-added-wrap';
      addedEl.hidden = true;
      addedEl.innerHTML =
        '<div class="f-added__scrim" data-f-added-close></div>' +
        '<div class="f-added" role="dialog" aria-modal="false" aria-labelledby="f-added-h">' +
          '<div class="f-added__head"><p class="f-added__h" id="f-added-h"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Added to your bag</p>' +
          '<button type="button" class="f-added__x" data-f-added-close aria-label="Close"><svg width="18" height="18" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l12 12M17 5L5 17"/></svg></button></div>' +
          '<div class="f-added__item"><div class="f-added__img"><img alt="" width="96" height="96"></div><div class="f-added__info"><p class="f-added__name"></p><p class="f-added__var"></p><p class="f-added__price"></p></div></div>' +
          '<a class="f-btn f-btn--ink f-added__checkout" href="/checkout">Checkout</a>' +
          '<div class="f-added__links"><a class="f-added__view" href="/cart">View bag (<span data-f-added-count>1</span>)</a><button type="button" class="f-added__keep" data-f-added-close>Keep shopping</button></div>' +
          '<p class="f-added__note">Free US &amp; Canada shipping &middot; 100-day fit guarantee</p>' +
        '</div>';
      document.body.appendChild(addedEl);
      addedEl.addEventListener('click', function (e) { if (e.target.closest('[data-f-added-close]')) addedClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') addedClose(); });
    }
    var img = addedEl.querySelector('.f-added__img img');
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    if (src) { img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.alt = item.product_title || ''; img.parentNode.hidden = false; }
    else img.parentNode.hidden = true;
    addedEl.querySelector('.f-added__name').textContent = item.product_title || item.title || '';
    addedEl.querySelector('.f-added__var').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var sel = document.querySelector('[data-f-size-select]');
    var opt = sel && sel.value ? sel.options[sel.selectedIndex] : null;
    var priceText = opt && opt.getAttribute('data-price');
    if (!priceText) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { priceText = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((item.final_price || item.price || 0) / 100); } catch (e) { priceText = ''; }
    }
    addedEl.querySelector('.f-added__price').textContent = priceText || '';
    addedEl.hidden = false;
    document.documentElement.classList.add('f-added-open');
    addedEl.querySelector('.f-added__checkout').focus({ preventScroll: true });
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.item_count || 0;
      addedEl.querySelector('[data-f-added-count]').textContent = n;
      document.querySelectorAll('[data-f-cart-count]').forEach(function (el) {
        el.textContent = n; el.setAttribute('data-count', n);
        var a = el.closest('a'); if (a) a.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items'));
      });
    }).catch(function () {});
  }

  /* ---- Chat bubble vs payment buttons (owner, 2026-10-06): on phones the Inbox chat bubble sat on top of the Shop Pay /
     express buttons (cart and product page). Hide the bubble while those buttons are on screen; it comes back on scroll. ---- */
  function initPayChat() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.f-cart__wallets, .f-cart__checkout, [data-f-paybtn]');
    if (!targets.length) return;
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
      document.documentElement.classList.toggle('f-pay-inview', seen.size > 0);
    });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---- Old vs new site test (owner, 2026-10-02): tag the cart with site_version = new, so the order shows which site it came
     from (Shopify admin > order > Additional details). Only once the cart has something in it (no empty carts created), once
     per session. Product-page buys also carry the hidden line property _site_version (sections/form-product.liquid). ---- */
  function tagSiteVersion() {
    if (!window.fetch) return;
    var done = ''; try { done = sessionStorage.getItem('f_site_tagged') || ''; } catch (e) {}
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) return;
      var key = String(c.token || '').split('?')[0];
      function mark() { try { sessionStorage.setItem('f_site_tagged', key); } catch (e) {} }
      if (done === key || (c.attributes && c.attributes.site_version === 'new')) { mark(); return; }
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { site_version: 'new' } }) })
        .then(function (r) { if (r.ok) mark(); });
    }).catch(function () {});
  }

  function ready() {
    initQuiz();
    initVideos();
    initRows();
    initChatLinks();
    setTimeout(lqApplyAttrs, 1500);
    setTimeout(tagSiteVersion, 2500);
    initPayChat();
    if (document.querySelector('.f-cart__qty')) initCartQty();
    document.querySelectorAll('[data-f-features]').forEach(initFeatures);
    document.querySelectorAll('[data-f-announce]').forEach(initAnnounce);
    document.querySelectorAll('[data-f-shop]').forEach(initShop);
    document.querySelectorAll('[data-f-header]').forEach(initNav);
    document.querySelectorAll('[data-f-header]').forEach(initMobileNav);
    document.querySelectorAll('[data-f-hero]').forEach(initHero);
    document.querySelectorAll('[data-f-offer-root]').forEach(initOffer);
    document.querySelectorAll('[data-f-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-f-pdp]').forEach(initSizes);
    document.querySelectorAll('[data-f-best-sellers]').forEach(initBestSellers);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
